export const TOP_TABLE_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Product Name",
    sortable: false,
    resizable: true
  },
  {
    key: "price",
    dataKey: "price",
    title: "Price",
    sortable: false,
    resizable: true
  },
  {
    key: "amount",
    dataKey: "amount",
    title: "Commission",
    sortable: false,
    resizable: true
  },
  {
    key: "influencerCount",
    dataKey: "influencerCount",
    title: "# of Influencers",
    sortable: false,
    resizable: true
  },
  {
    key: "applicantCount",
    dataKey: "applicantCount",
    title: "# of Applicants",
    sortable: false,
    resizable: true
  },
  {
    key: "videoCount",
    dataKey: "videoCount",
    title: "# of Videos",
    sortable: false,
    resizable: true
  },
  {
    key: "salesMade",
    dataKey: "salesMade",
    title: "Sales Earnings",
    sortable: false,
    resizable: true
  },
  {
    key: "expiresAt",
    dataKey: "expiresAt",
    title: "Expires On",
    sortable: false,
    resizable: true
  },
  {
    key: "share",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];

export const BOTTOM_TABLE_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Product Name",
    sortable: false,
    resizable: true
  },
  {
    key: "price",
    dataKey: "price",
    title: "Price",
    sortable: false,
    resizable: true
  },
  {
    key: "amount",
    dataKey: "amount",
    title: "Commission",
    sortable: false,
    resizable: true
  },
  {
    key: "influencerCount",
    dataKey: "influencerCount",
    title: "# of Influencers",
    sortable: false,
    resizable: true
  },
  {
    key: "applicantCount",
    dataKey: "applicantCount",
    title: "# of Applicants",
    sortable: false,
    resizable: true
  },
  {
    key: "videoCount",
    dataKey: "videoCount",
    title: "# of Videos",
    sortable: false,
    resizable: true
  },
  {
    key: "salesMade",
    dataKey: "salesMade",
    title: "Sales Earnings",
    sortable: false,
    resizable: true
  },
  {
    key: "expiresAt",
    dataKey: "expiresAt",
    title: "Expired On",
    sortable: false,
    resizable: true
  },
  {
    key: "share",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];
